import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Vendors
import React from 'react';
// Components
import { ParagraphComponent } from '../paragraph/paragraph.component';
// Hooks
import { useTitleStylesHook } from './hooks/title-styles.hook';
// Styles
import { BuilderStyled, LeftWrapper, RightWrapper, TitleMainWrapperStyled, } from './title.component.styled';
import { TitleVariantsType } from '../../designSystem/reloaded/commons/components/title/variants';
const Title = ({ additionalInfo, component, showBuilder = true, title, customTypography, variant = TitleVariantsType.DEFAULT, testId }, ref) => {
    const { setRef, styles } = useTitleStylesHook({ ref, variant });
    return (_jsxs(TitleMainWrapperStyled, { additionalInfo: additionalInfo, ref: setRef, styles, children: [_jsxs(LeftWrapper, { styles, children: [_jsx(ParagraphComponent, { component: component, customTypography: customTypography ? customTypography : styles?.title, testId: testId, children: title }), showBuilder && _jsx(BuilderStyled, { styles })] }), additionalInfo && _jsx(RightWrapper, { styles, children: additionalInfo })] }));
};
const TitleComponent = React.forwardRef(Title);
export { TitleComponent };
//# sourceMappingURL=title.component.js.map